import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToWorkspaceClosure,
  type WorkspaceClosure,
  type WorkspaceClosureApiResource,
} from './workspaceClosureApi.types';

const WORKSPACE_CLOSURE_PATH = '/me/workspace/closure';

export async function fetchWorkspaceClosure(): Promise<WorkspaceClosure> {
  const response = await httpClient.get<WorkspaceClosureApiResource>(WORKSPACE_CLOSURE_PATH);
  return mapApiResourceToWorkspaceClosure(response.data);
}

export async function scheduleWorkspaceClosure(workspaceName: string): Promise<WorkspaceClosure> {
  const response = await httpClient.post<WorkspaceClosureApiResource>(WORKSPACE_CLOSURE_PATH, {
    workspace_name: workspaceName,
  });
  return mapApiResourceToWorkspaceClosure(response.data);
}

export async function cancelWorkspaceClosure(): Promise<WorkspaceClosure> {
  const response = await httpClient.delete<WorkspaceClosureApiResource>(WORKSPACE_CLOSURE_PATH);
  return mapApiResourceToWorkspaceClosure(response.data);
}
